import { render, staticRenderFns } from "./cara-kerja.vue?vue&type=template&id=d32b142c&scoped=true"
import script from "./cara-kerja.vue?vue&type=script&lang=js"
export * from "./cara-kerja.vue?vue&type=script&lang=js"
import style0 from "./cara-kerja.vue?vue&type=style&index=0&id=d32b142c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d32b142c",
  null
  
)

export default component.exports